/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Mark_AppliedInputs */

const en_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Applied`)
};

const de_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als beworben markieren`)
};

const fr_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer comme postulé`)
};

const es_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como postulado`)
};

const it_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna come candidata`)
};

const nl_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markeer als gesolliciteerd`)
};

const pl_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznacz jako wysłaną`)
};

const fi_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkitse haetuksi`)
};

const da_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markér som ansøgt`)
};

const sv_jobs_mark_applied = /** @type {(inputs: Jobs_Mark_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markera som ansökt`)
};

/**
* | output |
* | --- |
* | "Mark Applied" |
*
* @param {Jobs_Mark_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_mark_applied = /** @type {((inputs?: Jobs_Mark_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Mark_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_mark_applied(inputs)
	if (locale === "fr") return fr_jobs_mark_applied(inputs)
	if (locale === "es") return es_jobs_mark_applied(inputs)
	if (locale === "it") return it_jobs_mark_applied(inputs)
	if (locale === "nl") return nl_jobs_mark_applied(inputs)
	if (locale === "pl") return pl_jobs_mark_applied(inputs)
	if (locale === "fi") return fi_jobs_mark_applied(inputs)
	if (locale === "da") return da_jobs_mark_applied(inputs)
	if (locale === "sv") return sv_jobs_mark_applied(inputs)
	return en_jobs_mark_applied(inputs)
});